<script lang="ts">
    import type {DirectoryNode} from 'typings/portaro.be.types';
    import {getMediaViewerContext} from '../../../lib/mv-context';
    import {createEventDispatcher} from 'svelte';
    import {get} from 'svelte/store';
    import {getLocalization} from 'core/svelte-context/context';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import MvContextMenuDivider from './MvContextMenuDivider.svelte';
    import MvContextMenuTitle from './MvContextMenuTitle.svelte';
    import {
        handleDirectoryCreateClick,
        handleDirectoryCreateTextFileClick,
        handleDirectoryDeleteClick,
        handleDirectoryEditMetadataClick,
        handleDirectoryUploadLocalFilesClick
    } from '../../../lib/mv-file-explorer-handlers';

    export let directory: DirectoryNode;
    export let contentsOpen: boolean;

    const context = getMediaViewerContext();
    const localize = getLocalization();
    const dispatch = createEventDispatcher<{ 'toggle-contents-open': boolean }>();

    const handleToggleContentsOpenClick = () => {
        const fileExplorerViewType = get(context.fileExplorerViewType);

        if (fileExplorerViewType === 'grid') {
            context.setFileExplorerSelectedDirectory(directory);
            return;
        }

        dispatch('toggle-contents-open', !contentsOpen);
    }
</script>

<MvContextMenuTitle>
    {localize(/* @kp-localization mediaviewer.fileExplorer.DirectoryContextLabel */ 'mediaviewer.fileExplorer.DirectoryContextLabel')}
</MvContextMenuTitle>

<MvContextMenuDivider/>

{#if context.canEdit}
    <KpButton isBlock
              buttonStyle="default-viewer-themed"
              on:click={() => handleDirectoryEditMetadataClick(context, directory)}>

        <IconedContent icon="edit">
            {localize(/* @kp-localization mediaviewer.fileExplorer.EditDirectory */ 'mediaviewer.fileExplorer.EditDirectory')}
        </IconedContent>
    </KpButton>
{/if}

<KpButton isBlock
          buttonStyle="default-viewer-themed"
          on:click={handleToggleContentsOpenClick}>

    <IconedContent icon="{contentsOpen ? 'folder' : 'folder-open'}">
        {contentsOpen
            ? localize(/* @kp-localization mediaviewer.fileExplorer.HideDirectoryContents */ 'mediaviewer.fileExplorer.HideDirectoryContents')
            : localize(/* @kp-localization mediaviewer.fileExplorer.ShowDirectoryContents */ 'mediaviewer.fileExplorer.ShowDirectoryContents')}
    </IconedContent>
</KpButton>

{#if context.canEdit}
    <MvContextMenuDivider/>

    <KpButton isBlock
              buttonStyle="accent-blue-new"
              on:click={() => handleDirectoryUploadLocalFilesClick(context, directory)}>

        <IconedContent icon="cloud-upload">
            {localize(/* @kp-localization mediaviewer.fileExplorer.UploadDirectoryFiles */ 'mediaviewer.fileExplorer.UploadDirectoryFiles')}
        </IconedContent>
    </KpButton>

    <KpButton isBlock
              buttonStyle="default-viewer-themed"
              on:click={() => handleDirectoryCreateClick(context, directory)}>

        <IconedContent icon="add-folder">
            {localize(/* @kp-localization mediaviewer.fileExplorer.CreateNewSubdirectory */ 'mediaviewer.fileExplorer.CreateNewSubdirectory')}
        </IconedContent>
    </KpButton>

    <KpButton isBlock
              buttonStyle="default-viewer-themed"
              on:click={() => handleDirectoryCreateTextFileClick(context, directory)}>

        <IconedContent icon="add-document">
            {localize(/* @kp-localization mediaviewer.fileExplorer.CreateNewTextFile */ 'mediaviewer.fileExplorer.CreateNewTextFile')}
        </IconedContent>
    </KpButton>

    <MvContextMenuDivider/>

    <KpButton isBlock
              buttonStyle="danger-new"
              on:click={() => handleDirectoryDeleteClick(context, directory)}>

        <IconedContent icon="remove-folder">
            {localize(/* @kp-localization mediaviewer.fileExplorer.DeleteDirectory */ 'mediaviewer.fileExplorer.DeleteDirectory')}
        </IconedContent>
    </KpButton>
{/if}